<script lang="ts" setup>
  import { getUrlParams, sendMessageToParent } from '@/utils/common'

  const deviceStore = useDeviceStore()
  const commonStore = useCommonStore()
  // const route = useRoute()
  const query = getUrlParams(window.location.href)
  const hasRequiredParams = query.laravel_session && query.domain
  if (hasRequiredParams) {
    useUserStore().setToken(query.laravel_session?.toString())
    commonStore.setDomain(query.domain?.toString())
    commonStore.setLang(query.lang?.toString())
  }

  const resizeObserver = ref<ResizeObserver | null>(null)
  onMounted(() => {
    deviceStore.checkDevice()
    window.addEventListener('resize', deviceStore.checkDevice)
    watchMicroContainerResize()
    sendMessageToParent({
      type: 'pageMounted',
      text: 'page jump'
    })
  })

  onUnmounted(() => {
    window.removeEventListener('resize', deviceStore.checkDevice)
    if (resizeObserver.value) {
      // 在组件卸载时停止观察并销毁 ResizeObserver 实例
      resizeObserver.value.disconnect()
      resizeObserver.value = null
    }
  })

  // 监听微服务页面body的高度变化
  const watchMicroContainerResize = () => {
    // 获取目标元素
    const target = document.body
    // 创建 ResizeObserver 实例
    resizeObserver.value = new ResizeObserver(entries => {
      for (const entry of entries) {
        if (entry.target === target) {
          const newHeight = entry.contentRect.height
          sendMessageToParent({
            type: 'pageHeight',
            text: newHeight
          })
        }
      }
    })
    // 开始观察目标元素
    resizeObserver.value.observe(target)
  }
</script>

<script setup></script>

<template>
  <router-view />
</template>

<style>
  #app {
    display: flex;
    justify-content: center;
    min-height: 100%;
    overflow: hidden;
  }
</style>
